module.exports = __webpack_public_path__ + "static/media/karthik_das.5697b6f4.png";